import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { environment } from '../environments/environment';
import { Observable, throwError } from 'rxjs';
import { catchError, map } from 'rxjs/operators';

export interface CacheKey {
  key: string;
  valueId: string;
}

export interface CacheKeyResponse {
  result: CacheKey[];
  count: number;
}

@Injectable({
  providedIn: 'root'
})
export class CacheService {
  private baseUrl = `${environment.apiConfig.uri}Admin/`;

  constructor(private http: HttpClient) { }

  getCacheKeys(): Observable<CacheKey[]> {
    return this.http.post<CacheKey[]>(`${this.baseUrl}GetCacheKeys`, {}).pipe(
      catchError(error => throwError(() => error))
    );
  }

  listCacheKeys(): Observable<string[]> {
    return this.http.get<string[]>(`${this.baseUrl}ListCacheKeys`).pipe(
      catchError(error => throwError(() => error))
    );
  }

  getCacheValue(key: string): Observable<any> {
    const params = new HttpParams().set('key', key);
    return this.http.get(`${this.baseUrl}GetCacheValue`, { params, responseType: 'text' }).pipe(
      map(response => {
        try {
          return JSON.parse(response);
        } catch {
          return response; 
        }
      }),
      catchError(error => throwError(() => error))
    );
  }

  deleteCacheKey(key: string): Observable<void> {
    const params = new HttpParams().set('key', key);
    return this.http.delete<void>(`${this.baseUrl}DeleteCacheKey`, { params }).pipe(
      catchError(error => throwError(() => error))
    );
  }

  clearAllCache(): Observable<void> {
    return this.http.delete<void>(`${this.baseUrl}ClearAllCache`).pipe(
      catchError(error => throwError(() => error))
    );
  }
}
